import React from 'react';
import ModalComponent from '../../ModalComponent';
import { connect } from 'react-redux';

import { Form, HelpBlock } from 'react-bootstrap';
import {modals as ModalDuck, modals} from "ducks";

import FontAwesome from 'utils/FA';
import './styles/BulkContractCreation.scss';
import DOMPurify from "dompurify";
import apiFetch from 'utils/apiFetch'
import { faClock } from '@fortawesome/pro-light-svg-icons/faClock';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { faSync } from '@fortawesome/pro-light-svg-icons/faSync';
import ValidationErrors from '../../forms/ValidationErrors';
import Routes from '../../../../routes';

class ContractGenerationVerification extends React.Component {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.state = {
      value: '',
      saving: false,
      contractFieldsHTML: undefined,
      contractFieldError: undefined
    };
  };

  onSubmit() {
    this.setState({saving: true});

    let selector = $('.contract-fields .controls');
    let answers = new Map();

    selector.find('select,input:visible').map((i, el) => {
      let v = answers.get(el.name);
      let answered = true;

      if((el.type === "checkbox" || el.type === "radio") && !el.checked){
        answered = false;
      }

      if(answered){
        if(v){
          v.push(el.value);
        } else {
          v = [el.value];
          answers.set(el.name, v);
        }
      } else {
        if(!v){
          answers.set(el.name, [])
        }
      }
    }).get();

    let {ids, bulk, workflow} = this.props;
    let url = workflow === 'pending' ?  Routes.generate_contracts_path() :  Routes.regenerate_contract_path(ids);

    apiFetch.post(this.state, '', {ids: ids, fields: answers}, { baseUrl: url })
      .then(response => {
        if (response.status === 'ok') {
          if (response.warning) {
            Utility.warningMessage(`The contract was generated, but with the following errors:<ul>${response.warning.map(item => `<li>${item}</li>`).join('')}</ul>`);
          } else {
            if (bulk) {
              Utility.successMessage('The Bulk Contract Generation job has successfully started, but may take some time to finish completely. Refresh the page to see the results.');
            } else {
              Utility.successMessage('Contract Generation job has successfully started, but may take some time to complete. Refresh the page to see the results.');
            }
          }
          ReactComponent.dispatch(modals.actions.hide_all());
        } else {
          this.setState({contractFieldError: response, saving: false});
        }
      }
    );
  }

  componentDidMount(){
    let { workflow } = this.props;

    if(workflow === 'pending'){
      let contractFieldsHTML = $('#contract-fields-magic-container').html();
      this.setState({
        contractFieldsHTML: contractFieldsHTML
      });
    }
  }

  static mapDispatchToProps = (dispatch, props) => ({
    closeOne: (() => dispatch(ModalDuck.actions.hide())),
    closeAll: (() => dispatch(ModalDuck.actions.hide_all()))
  });

  getConfirmationState(passval) {
    const val = this.state.value.toLowerCase();
    if (val === passval.toLowerCase()) return 'success';
    else if (val !== passval.toLowerCase()) return 'warning';
    return null;
  }

  handleChange(e) {
    this.setState({ value: e.target.value });
  }

  render() {
    let { pass, title, workflow, bulk, closeAll, closeOne } = this.props;
    let regen = workflow === 'pending';
    let { saving, contractFieldsHTML, contractFieldError } = this.state;
    let disabled = (this.getConfirmationState(pass) === 'warning' || saving) ? 'disabled' : '';
    let buttons = [
      <button className="btn btn-primary" onClick={closeOne}>Back</button>,
      <button className="btn btn-success" disabled={disabled} type="submit" onClick={() => this.onSubmit()}>{saving ? 'Submitting...' : 'Submit'}</button>
    ];

    return (
      <div>
        <ModalComponent title={`Confirm Contract ${title}`} onClose={closeAll} buttons={buttons}>
          <div className="contract-generation-second-step-modal">
            { ( saving &&
              <div><FontAwesome name="spinner" spin/> Generating...</div> )
              ||
              <React.Fragment>
                {contractFieldError && <ValidationErrors fieldNames={{base: ''}} errors={contractFieldError}/>}
                <div className="contract-fields" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(contractFieldsHTML)}}/>
                <Form.Group
                  controlId="generationConfirmationText"
                >
                  <div className="contract-process-help-text">
                    {!regen &&
                      <Form.Label>
                        <p>Once confirmed, this action cannot be undone!</p>
                        <p className="contract-bulk-danger-permanent">Finalsite Enrollment cannot recover contracts or related data that is deleted
                          by this action.</p>
                      </Form.Label>
                    }
                    {regen &&
                      <Form.Label>
                        <p><FontAwesome icon={faClock}/><span> Once you confirm this action it may take a few minutes to complete.</span></p>
                        <p><FontAwesome icon={faCheck}/><span> You can continue working while this process is running.</span></p>
                        {bulk &&
                          <p><FontAwesome icon={faSync}/><span> Upon refresh, the Contract Status will indicate "Generated" for each student, once complete.</span></p>
                        }
                      </Form.Label>
                    }
                  </div>
                  <Form.Control
                    name="confirmation-text-field"
                    type="text"
                    value={this.state.value}
                    placeholder={"Enter " + pass}
                    onChange={this.handleChange}
                    autoComplete="off"
                  />
                  <Form.Text muted>To confirm that you have verified the applicable fees and are ready to perform this action, type {`${pass}`}.</Form.Text>
                </Form.Group>
              </React.Fragment>
            }
          </div>
        </ModalComponent>
      </div>
    )
  }
}


export default connect(null, ContractGenerationVerification.mapDispatchToProps)(ContractGenerationVerification)
